import React, {useState,useEffect,useRef} from 'react'
import { Formik, Field } from 'formik'
import { Table,Button,Icon,Form,Select,Input,List,Image,Label,TextArea,Message } from 'semantic-ui-react'
import Paginations from '../../../config/pagination'
import EntryList from '../../../config/entries'
import {WindowReload, WindowURLClient, WindowLocationClient} from '../../../config/settings'
import Alertmessage from '../../../config/alert'
import axios from 'axios'
import renderHTML from 'react-render-html'
import {insertvalidations} from './validate'


export default function HelpDeskComponent(props) {

	const [alert,setalert] = useState(false);
	const [Alertcontent,setAlertcontent] = useState({});
	function Alertclose(){setalert(false);}
	function Alertconfirm(data){if(data.confirm==true){setalert(false);}}
	function Alertdelete(data){
		if(data.delete==true){
		}
	}

	/*-------------------------------------------------------------------------
	 Forms: Adding and Updating
	--------------------------------------------------------------------------*/
	const [state,setstate] = useState({
		priority:'',
		department_to:'',
		subject:'',
		message:''
	});
	function handleSubmitForm(values, props){

		setAlertcontent({intent:'inline_spinner',settings:{centered:true,icon:'spinner',title:'Processing',html:"This won't take long, please wait...",footer:'none'}});
		setalert(true);

		let formData = new FormData();
		formData.append('type','help_support');
		formData.append('info',JSON.stringify(values));
		axios.post('/client/support/http.php',formData)
		.then(function (response) {

			let obj = response.data;

			if(obj=='success'){
				setAlertcontent({intent:'alert',settings:{centered:false,icon:'success',title:'Congratulations',html:"Message successfully send."}});
				setalert(true);
				setTimeout(function() {WindowReload();},2000);
				return false;
			}

			if(obj=='error'){
				setAlertcontent({intent:'alert',settings:{centered:false,icon:'error',title:'Saving Error!',html:"Message not successfully send. Please try again later.",footer:'yes'}});
				setalert(true);
				setTimeout(function() {WindowReload();},2000);
				return false;
			}

			setAlertcontent({intent:'alert',settings:{centered:false,icon:'warning',title:'Input Error!',html:"Please correct the input errors.",footer:'yes'}});
			setalert(true);
			setTimeout(function() {setalert(false);},2000);
			Object.keys(obj).forEach(function(key) {
        props.setErrors(obj);
      });

		})
		.catch(function (error){
			setAlertcontent({intent:'alert',settings:{centered:false,icon:'warning',title:'Server Error!',html:"Problem connecting to the server. Contact the administrator.",footer:'yes'}});
			setalert(true);
			setTimeout(function() {WindowReload();},2000);
		});
	}




	useEffect(()=>{
	},[]);


	return (
		<React.Fragment>
      <div className="page-wrapper">
				{alert&&<Alertmessage close={Alertclose} data={Alertcontent} confirm={Alertconfirm} delete={Alertdelete}/>}
				<Form>
					<Formik
					  enableReinitialize
						initialValues={state}
						validationSchema={insertvalidations}
						onSubmit={handleSubmitForm}
						render={formProps => {
						const { values, isSubmitting, errors, handleChange, handleBlur, handleSubmit, isValid, touched, setFieldValue } = formProps


						return(
			         <div className="panel">
			            <div className="panel-header">HELP DESK ACCOUNT SUPPORT</div>
			            <div className="panel-body">

									 <div className="formtwo-wrapper">
									 		<div>

										  <div className="inlinformtwo">
 											<div><label>Priority</label></div>
 											<div>
 											<Form.Group widths="equal">
 												<Field name="priority">
 														{({ field, form }) => (
 														<Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
														 <Select selectOnBlur={false}
																{...field}
																options={[
																		{ key: '1', text: 'Low', value: 'Low' },
																		{ key: '2', text: 'Normal', value: 'Normal' },
																		{ key: '3', text: 'High', value: 'High' },
																		{ key: '4', text: 'Emergency', value: 'Emergency' },
																]}
																onChange={(e, { value }) => {
																	setFieldValue(field.name,value);
																}}/>
 															{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
 														</Form.Field>
 														)}
 												</Field>
 											</Form.Group>
 											</div>
 									 </div>{/*.inlinform*/}


									<div className="inlinformtwo">
											 <div><label>To</label></div>
											 <div>
											 <Form.Group widths="equal">
												 <Field name="department_to">
														 {({ field, form }) => (
														 <Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
															<Select selectOnBlur={false}
																 {...field}
																 options={[
																		 { key: '1', text: 'Trading Department (Trading Advisor)', value: 'Trading Department (Trading Advisor)' },
																		 { key: '2', text: 'Account Department (Account Clearing)', value: 'Account Department (Account Clearing)' },
																 ]}
																 onChange={(e, { value }) => {
																	 setFieldValue(field.name,value);
																 }}/>
															 { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
														 </Form.Field>
														 )}
												 </Field>
											 </Form.Group>
											 </div>
										</div>{/*.inlinform*/}

										 <div className="inlinformtwo">
											<div><label>Subject</label></div>
											<div>
											<Form.Group widths="equal">
												<Field name="subject">
														{({ field, form }) => (
														<Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
															<Input {...field} onChange={handleChange}/>
															{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
														</Form.Field>
														)}
												</Field>
											</Form.Group>
											</div>
									 </div>{/*.inlinform*/}

									 <div className="inlinformtwo">
										<div><label>Message</label></div>
										<div>
										<Form.Group widths="equal">
											<Field name="message">
													{({ field, form }) => (
													<Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
														<TextArea {...field} onChange={handleChange} rows='7'/>
														{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
													</Form.Field>
													)}
											</Field>
										</Form.Group>
										</div>
								 </div>{/*.inlinform*/}


							</div>{/*.left column*/}


							<div></div>{/*.right column*/}

							</div>{/*.end wrapper*/}


									</div>{/*.panel-body*/}
			            <div className="panel-footer">
											<Button className='secondary' size='large' icon="send" content='SEND' onClick={handleSubmit}/>
									</div>
			         </div>

						 )}}/>
					</Form>



      </div>
    </React.Fragment>
  )
}
